const DEFAULT_MAX_WIDTH = 1280;
const FALLBACK_RATIO = 9 / 16;

/** Calcula el tamaño del thumbnail conservando el aspect ratio del video. */
export const computeThumbSize = (
  videoWidth: number,
  videoHeight: number,
  maxWidth: number = DEFAULT_MAX_WIDTH
): { width: number; height: number } => {
  if (!videoWidth || !videoHeight) {
    return { width: maxWidth, height: Math.round(maxWidth * FALLBACK_RATIO) };
  }
  if (videoWidth <= maxWidth) {
    return { width: videoWidth, height: videoHeight };
  }
  return {
    width: maxWidth,
    height: Math.round(videoHeight * (maxWidth / videoWidth)),
  };
};

/**
 * Dibuja el fotograma ACTUAL del <video> a un canvas y resuelve un Blob WebP.
 * El video ya debe estar posicionado (currentTime) y con metadata cargada.
 */
export const captureVideoFrame = (
  video: HTMLVideoElement,
  maxWidth: number = DEFAULT_MAX_WIDTH
): Promise<Blob> =>
  new Promise((resolve, reject) => {
    const { width, height } = computeThumbSize(
      video.videoWidth,
      video.videoHeight,
      maxWidth
    );
    const canvas = document.createElement('canvas');
    canvas.width = width;
    canvas.height = height;
    const ctx = canvas.getContext('2d');
    if (!ctx) {
      reject(new Error('canvas 2d context unavailable'));
      return;
    }
    ctx.drawImage(video, 0, 0, width, height);
    canvas.toBlob(
      (blob) => {
        if (blob) resolve(blob);
        else reject(new Error('toBlob returned null'));
      },
      'image/webp',
      0.85
    );
  });
